import { render } from "./ObservacoesPedidoEmAndamento.vue?vue&type=template&id=a1e3e4c4&scoped=true"
import script from "./ObservacoesPedidoEmAndamento.vue?vue&type=script&lang=js"
export * from "./ObservacoesPedidoEmAndamento.vue?vue&type=script&lang=js"

import "./ObservacoesPedidoEmAndamento.vue?vue&type=style&index=0&id=a1e3e4c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e3e4c4"]])

export default __exports__